import { useQuery } from '@apollo/client';

import GetCourseBySlugForPromotionBanner from 'bundles/promotions/queries/GetCourseBySlugForPromotionBannerQuery.graphql';
import type {
  GetCourseBySlugForPromotionBannerQuery,
  GetCourseBySlugForPromotionBannerQueryVariables,
} from 'bundles/promotions/queries/__generated__/GetCourseBySlugForPromotionBannerQuery';

export type PropsFromUseGetCourseBySlug = {
  course?: {
    id: string;
    s12nIds?: string[];
  };
};

export const useGetCourseBySlug = (courseSlug?: string) => {
  const { data } = useQuery<GetCourseBySlugForPromotionBannerQuery, GetCourseBySlugForPromotionBannerQueryVariables>(
    GetCourseBySlugForPromotionBanner,
    {
      variables: { slug: `${courseSlug}` },
      skip: !courseSlug,
      context: { clientName: 'gatewayGql' },
    }
  );

  const courseData = data?.Course?.queryBySlug;

  if (!courseData) {
    return {};
  }

  const course = {
    id: courseData.id,
    s12nIds: courseData.specializations.map(({ id }) => id),
  };

  return {
    course,
  };
};
